import React, { Component, cloneElement, PropTypes } from 'react';
import debounce from 'lodash.debounce';
import { connect } from 'react-redux';

import {
  search,
  sendInvitation,
  resendInvitation,
  acceptConnection,
  ignoreConnection,
  fakeResendInvitation,
  openPopover,
  closePopover,
  updateCustomizedMsg,
} from '../../stores/partner-finder/partnerFinder-actions';

import { openUpgradeFrom } from '../../stores/ui/components/upgrade/upgrade-actions';

class ContainerPartnerFinder extends Component {

  constructor(props) {
    super(props);

    this.state = { };
  }

  search = (searchParams = {}, pagination, noCount) => {
    // console.log('search !', { searchParams });
    const { dispatch, user } = this.props;
    searchParams.destinationsSold = searchParams.destinationsSold || [];
    const defaultCountry = this.props.user.company.address.country || 'Australia';
    searchParams.companyType = searchParams.companyType || (user.user.type === 'Contractor' ? 'Supplier' : 'Contractor');
    if (searchParams.companyType === 'Supplier') {
      searchParams.country = searchParams.country || defaultCountry;
      searchParams.buyerClientsFrom = '';
      searchParams.destinationsSold = [];
    } else if (searchParams.companyType === 'Contractor') {
      searchParams.country = searchParams.country || '';
      searchParams.buyerClientsFrom = searchParams.buyerClientsFrom || '';
      searchParams.destinationsSold = [searchParams.destinationsSold[0] || defaultCountry];
    } else if (searchParams.companyType === 'TechAndServices') {
      searchParams.country = '';
      searchParams.destinationsSold = [];
      searchParams.buyerClientsFrom = '';
    } else {
      searchParams.destinationsSold = [searchParams.country || defaultCountry];
      searchParams.country = searchParams.country || defaultCountry;
      searchParams.buyerClientsFrom = '';
    }
    searchParams.isForPremiumUser = (user.billingPlan === 'connected' || user.billingPlan === 'unlimited');
    searchParams.page = undefined;
    // no aditional country filter for non-buyer types
    if (searchParams.companyType !== 'Contractor') {
      searchParams.buyerClientsFrom = '';
      searchParams.buyerLocatedIn = '';
    }
    dispatch(search(searchParams, pagination, noCount));
  };

  showHelpBox = (existingBoxes, boxName) => {
    if (!existingBoxes) return true;
    return existingBoxes.findIndex((box) => box.name === boxName) < 0;
  }

  loadMore = (page) => {
    const { dispatch, partnerFinder } = this.props;
    dispatch(search(Object.assign({}, partnerFinder.searchParams, { page }), true, true));
  };

  searchWithInput = debounce((input) => {
    const { partnerFinder } = this.props;
    const params = partnerFinder.searchParams;
    params.companyOrLocationName = input;
    this.search(params);
  }, 400);

  sendInvitation = (customMsg, receiverInfo) => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    dispatch(sendInvitation(customMsg, receiverInfo))
    .then(() => {
      triggerSnackBarMessage({ message: 'Invitation Sent' });
    })
    .catch(() => {
      triggerSnackBarMessage({ message: 'Sending Invitation Failed' });
    });
  };

  resendConnection = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    dispatch(resendInvitation(connectionId))
    .then(() => {
      triggerSnackBarMessage({ message: 'Invitation Sent' });
    })
    .catch(() => {
      triggerSnackBarMessage({ message: 'Resending Invitation Failed' });
      // dispatch(undoConnectionChange());
    });
  };

  fakeResendInvitation = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    dispatch(fakeResendInvitation(connectionId))
    .then(() => {
      triggerSnackBarMessage({ message: 'Invitation Sent' });
    })
    .catch(() => {
      triggerSnackBarMessage({ message: 'Resending Invitation Failed' });
    });
  };

  acceptConnection = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    dispatch(acceptConnection(connectionId))
    .then(() => {
      triggerSnackBarMessage({ message: 'Invitation Accepted' });
    })
    .catch(() => {
      triggerSnackBarMessage({ message: 'Accepting Connection Failed' });
      // dispatch(undoConnectionChange());
    });
  };

  ignoreConnection = connectionId => {
    const { dispatch, triggerSnackBarMessage } = this.props;
    dispatch(ignoreConnection(connectionId))
    .then(() => {
      triggerSnackBarMessage({ message: 'Connection Request Ignored' });
    })
    .catch(() => {
      triggerSnackBarMessage({ message: 'Ignoring Connection Failed' });
    });
  };

  openUpgrade = (clickedCompany) => {
    const { dispatch } = this.props;
    dispatch(openUpgradeFrom('pfListConnectBtn', { clickedCompany }));
  }

	render() {
  const { children, ...props } = this.props;
  const extraProps = {
    search: this.search,
    loadMore: this.loadMore,
    searchWithInput: this.searchWithInput,
    sendInvitation: this.sendInvitation,
    resendConnection: this.resendConnection,
    acceptConnection: this.acceptConnection,
    ignoreConnection: this.ignoreConnection,
    fakeResendInvitation: this.fakeResendInvitation,
    router: this.context.router,
    openUpgrade: this.openUpgrade,
    ...props,
  };

  return (
    <div>
      {children ? cloneElement(children, extraProps) : undefined}
    </div>
  );
}
}

ContainerPartnerFinder.propTypes = {
  user: PropTypes.object,
  partnerFinder: PropTypes.object,
  triggerSnackBarMessage: PropTypes.func,
  dispatch: PropTypes.func,
  children: PropTypes.object,
};

const mapStateToProps = ({ partnerFinder }) => ({
  partnerFinder: partnerFinder.toJS(),
});

const mapDispatchToProps = dispatch => ({
  closePopover: () => dispatch(closePopover()),
  openPopover: payload => dispatch(openPopover(payload)),
  updateCustomizedMsg: payload => dispatch(updateCustomizedMsg(payload)),
});

ContainerPartnerFinder.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContainerPartnerFinder);



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/container-partnerFinder.jsx